var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoutesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrows/big arrow/right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M2.53943 9.50376L2.53943 6.0436M12.435 8.2047L8.20957 11.9606C8.02361 12.1259 7.72966 11.9939 7.72966 11.7451V10.6571C7.72966 10.0201 7.21327 9.50376 6.57627 9.50376H4.8462C4.5277 9.50376 4.2695 9.24556 4.2695 8.92706L4.2695 6.6203C4.2695 6.3018 4.5277 6.0436 4.8462 6.0436H6.57627C7.21327 6.0436 7.72966 5.52722 7.72966 4.89022V3.80225C7.72966 3.55345 8.02361 3.42144 8.20957 3.58673L12.435 7.34265C12.6931 7.57206 12.6931 7.9753 12.435 8.2047Z",
    stroke: "#B8B8C1",
    strokeWidth: 1.15338,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoutesIcon);
export default __webpack_public_path__ + "static/media/routes_icon.7e9ea830b5e39951ad7a472dd731fc4a.svg";
export { ForwardRef as ReactComponent };